import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
      title={theme === "dark" ? "Mode clair" : "Mode sombre"}
    >
      <div className="relative w-6 h-6">
        {/* Soleil - visible en mode clair */}
        <Sun
          className={`absolute inset-0 text-yellow-500 transition-all duration-300 ${
            theme === "dark"
              ? "opacity-0 rotate-90 scale-0"
              : "opacity-100 rotate-0 scale-100"
          }`}
          size={24}
        />

        {/* Lune - visible en mode sombre */}
        <Moon
          className={`absolute inset-0 text-blue-300 transition-all duration-300 ${
            theme === "dark"
              ? "opacity-100 rotate-0 scale-100"
              : "opacity-0 -rotate-90 scale-0"
          }`}
          size={24}
        />
      </div>
    </button>
  );
};

export default ThemeToggle;
